import { sidebarMenus } from 'components/Layout/sidebarMenus'

export const NO_ACCESS_PATH = '/no-access'
export const DASHBOARD_PATH = '/dashboard/view'
const DASHBOARD_MENU_ID = 1
// "My organization" needs an ?id= query built from the user; never pick it blindly.
const MY_ORGANIZATION_MENU_ID = 13

// Token menu claims are JSON-encoded id lists ("[12,17]"). A missing or malformed claim
// must behave like an empty one rather than throw inside a login .then().
export const parseMenuIds = (claim?: string | null): number[] => {
  try {
    const parsed = JSON.parse(claim || '[]')
    return Array.isArray(parsed) ? parsed.map(Number).filter(id => !Number.isNaN(id)) : []
  } catch {
    return []
  }
}

// Where a user lands when their role lacks the level's default module: the dashboard if
// they have it, else the first module they do have (sidebar order), else /no-access.
// Previously this was always /dashboard/view, which for a role without the dashboard
// menu rendered the "Dashboard not found" graphic beside an empty sidebar (#18775).
export const getFallbackLandingPath = (menuIds: number[]): string => {
  if (menuIds.includes(DASHBOARD_MENU_ID)) return DASHBOARD_PATH
  const first = sidebarMenus
    .flatMap(menu => (menu.items ? menu.items : menu))
    .find(
      menu =>
        menu.active &&
        menu.backendId !== MY_ORGANIZATION_MENU_ID &&
        menuIds.includes(menu.backendId),
    )
  return first?.path ?? NO_ACCESS_PATH
}
